import { IRoute, flatRouteList } from './utils';
import SessionRouter from './session';
import LoginRouter from './login';
import PartRouter from './part';
import BoardRouter from './board';
import { matchPath, match } from 'react-router-dom';

const ROUTES: IRoute[] = flatRouteList(SessionRouter, LoginRouter, BoardRouter, PartRouter);
export default ROUTES;
export function getRouteMatch(pathname: string): { route: IRoute, routeMatch: match } {
  let route, routeMatch;
  for (let r of ROUTES) {
    routeMatch = matchPath(location.pathname, {
      path: r.path,
      strict: true,
      exact: false
    });

    if (routeMatch) {
      route = r;
      break;
    }
  }
  return {
    route,
    routeMatch
  };
}
